export const WalkSchedulePicker = {
  ScheduleBtn: 'schedule-btn',
} as const;
